import classNames from "classnames";
import { ForwardedRef, forwardRef, memo, ReactNode } from "react";
import { Flex } from "../../flex";
import * as redoButtonCss from "./redo-button.module.css";

/**
 * @param children -- this should be a list of RedoButtons
 */
export interface RedoButtonGroupProps {
  children: ReactNode;
  squared?: boolean;
}

export const RedoButtonGroup = memo(
  forwardRef(function RedoButtonDropdown(
    { children, squared }: RedoButtonGroupProps,
    ref: ForwardedRef<HTMLButtonElement>,
  ) {
    return (
      <Flex
        className={classNames(redoButtonCss.buttonGroup, {
          [redoButtonCss.squared]: squared,
        })}
        gap="none"
        ref={ref}
      >
        {children}
      </Flex>
    );
  }),
);
